import { render, staticRenderFns } from "./KabBovenDigoel.vue?vue&type=template&id=e1c06440"
import script from "./KabBovenDigoel.vue?vue&type=script&lang=js"
export * from "./KabBovenDigoel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports